type NonFalsyValues<T> = {
  [K in keyof T as Exclude<T[K], Falsy> extends never ? never : K]: T[K];
};

export const omitEmpty = <T>(object: T) =>
  Object.fromEntries(
    Object.entries(object).filter(([, value]) => value)
  ) as NonFalsyValues<T>;
